export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 12c5.274 0 10 3.362 10 8a1 1 0 01-1 1H3a1 1 0 01-1-1c0-4.638 4.726-8 10-8zm0 2c-4.159 0-7.256 2.308-7.882 5h15.764c-.626-2.692-3.723-5-7.882-5zM12 2.5a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};